export function usePrograms() {
    onMounted(async () => {
        EventBus.$on(CHANGE_LOCALE_EVENT, load)
        await load()
    })

    onUnmounted(() => {
        EventBus.$off(CHANGE_LOCALE_EVENT, load)
    })

    const {locale} = useI18n()
    const load = async () => {
        if (locale.value !== supplierStore.programsLocale) await supplierStore.loadPrograms()
    }

    const programs = computed(() => supplierStore.programs)

    return {programs}
}
